// Rapor Tutarlılık Denetimi — kopya TEK kaynağı (UI'da satır içi metin yazılmaz).
// Yer tutucular {ad} biçimindedir; doldurma için `fillTemplate` (lib/period-ui) kullanılır.
import type { ReportCheckStatus } from "@mahir/shared";

export const REPORT_CHECK_COPY = {
  tab: "Tutarlılık",
  startButton: "Raporu denetle",
  estimating: "Tahmin hazırlanıyor…",
  sectionsTab: "Bölümler",
  showAll: "tümü ({n})",
  badgeChanged: "Denetimden sonra değişti",
  costLabel: "Tutarlılık denetimi",
  unsavedConfirm: {
    title: "Kaydedilmemiş değişiklikler var",
    body: "Bu bölümde kaydedilmemiş değişiklikler var. Başka bölüme geçerseniz bu değişiklikler kaybolur.",
    confirmLabel: "Değişiklikleri at ve geç",
    cancelLabel: "Bu bölümde kal",
  },
  filters: {
    group: "Filtreler",
    kind: "Tür",
    severity: "Önem",
    confidence: "Güven",
    status: "Durum",
    section: "Bölüm",
    all: "{label}: tümü",
  },
  confirm: {
    title: "Raporu denetle",
    body: "{sections} bölüm yaklaşık {tokens} bin token ile denetlenecek. Tahmini maliyet: {cost} USD, süre: yaklaşık {minutes} dk.",
    confirmLabel: "Denetimi başlat",
    cancelLabel: "Vazgeç",
  },
  status: {
    queued: "Sırada…",
    running: "Denetleniyor…",
    done: "Tamamlandı",
    failed: "Başarısız",
  },
  band: {
    stale: "Rapor denetimden sonra değişti: {n} bölüm ({codes})",
    result: "{n} bulgu",
    resultPartial: "{n} bulgu · {dropped} doğrulamada düştü",
  },
  kinds: { numeric: "Sayısal", narrative: "Anlatı", terminology: "Terminoloji" },
  levels: { high: "Yüksek", medium: "Orta", low: "Düşük" },
  findingStatus: { open: "Açık", resolved: "Giderildi", dismissed: "Yok sayıldı" },
  actions: {
    resolve: "Giderildi",
    dismiss: "Yok say",
    reopen: "Geri al",
    noteLabel: "Not",
  },
  evidenceIncomplete: "Eksik kanıt",
  quoteUnverified: "Alıntı metinde bulunamadı",
  empty: "Henüz denetim yapılmadı",
  history: { title: "Önceki denetimler", superseded: "Yeni denetimle değiştirildi" },
  errors: {
    input_changed:
      "Rapor tahmin alındıktan sonra değişti. Güncel tahmini inceleyip yeniden başlatın.",
    report_check_active: "Bu proje için zaten çalışan bir denetim var.",
    report_too_large: "Rapor tek seferde denetlenemeyecek kadar büyük.",
    no_content: "Denetlenecek içerik yok. Önce bölüm metinlerini üretin.",
    check_superseded: "Bu denetim yenisiyle değiştirildi; eski denetimde değişiklik yapılamaz.",
    timeout_stale: "Denetim zaman aşımına uğradı ve durduruldu.",
    enqueue_failed: "Denetim kuyruğa alınamadı. Lütfen tekrar deneyin.",
    requester_missing: "Denetimi başlatan kullanıcı bulunamadı.",
    output_truncated: "Model çıktısı yarıda kesildi; sonuç eksik olabilir.",
    llm_auth: "Yapay zekâ sağlayıcısı kimlik doğrulaması başarısız. Ayarları kontrol edin.",
    rate_limit: "Yapay zekâ sağlayıcısı istek sınırına ulaşıldı. Biraz sonra tekrar deneyin.",
    timeout: "Yapay zekâ sağlayıcısı zamanında yanıt vermedi.",
    network: "Yapay zekâ sağlayıcısına bağlanılamadı.",
    malformed: "Model yanıtı okunamadı.",
    unknown: "Beklenmeyen bir hata oluştu.",
  },
} as const;

export type ReportCheckErrorCode = keyof typeof REPORT_CHECK_COPY.errors;

/** Bilinmeyen kod → `unknown` metni. */
export function reportCheckErrorText(code: string | null | undefined): string {
  if (code && Object.prototype.hasOwnProperty.call(REPORT_CHECK_COPY.errors, code)) {
    return REPORT_CHECK_COPY.errors[code as ReportCheckErrorCode];
  }
  return REPORT_CHECK_COPY.errors.unknown;
}

export function reportCheckStatusText(status: ReportCheckStatus): string {
  return REPORT_CHECK_COPY.status[status];
}
